import React from 'react';
import {getVerticalFooterData} from './footer-data';
import * as S from "./FooterUI.styles";


function Footer (props){

const store = props && props.store && props.store.getState ? props.store.getState() : {};
const {common} = store || {};
const {footer} = common || {};

let body= [];
  if(footer && footer.length){
      for(let i in footer){
          const {title,block_title,links_data} = footer[i];
          if(title){

          
          body.push(

              <S.LinksList key={title}>
              <S.LinksListItemTitle>{title}</S.LinksListItemTitle>
              {links_data.map((item, idx) => (
                <S.LinksListItem key={idx}>
                  <a href={item.link}>{item.name}</a>
                </S.LinksListItem>
              ))}
            </S.LinksList>
  
          )
              }
      }
      
  }
return (
    <div style={{backgroundColor:'white',marginTop:'2rem'}}>
  <S.LinksWrapper>
     {body}
   
   
  </S.LinksWrapper>
  <div className="footerBox mobdn posRel" style={{padding:'0px'}}>
    <div className="marginAuto" style={{paddingLeft:'2.4rem'}}>
      <div className="col-md-12 col-sm-12 col-xs-12 footerAppLinks" style={{border:'none'}}>
        <div className="col-md-2 col-sm-3">
          <p className="ico14 fb">Follow Us</p>
          <div className="padT10">
            <a
              target="_blank"
              href="http://www.facebook.com/goibibo"
              className="fl padR10"
              title="facebook"
              rel="noopener"
            >
              <i className="ico24 lh1-2  greyLt icon-facebook"></i>
            </a>
            <a
              target="_blank"
              href="http://twitter.com/goibibo"
              className="fl padR10"
              title="Twitter"
              rel="noopener"
            >
              <i className="ico26 lh1-2  greyLt icon-twitter"></i>
            </a>
            <a
              target="_blank"
              href="http://www.youtube.com/user/goibibo"
              className="fl padR10"
              title="youtube"
              rel="noopener"
            >
              <i className="ico28 greyLt icon-youtube"></i>
            </a>
            <a
              target="_blank"
              href="https://plus.google.com/+goibibo/"
              className="fl"
              title="Google Plus"
              rel="noopener"
            >
              <span className="hd_vs fr_gplus margin0">&nbsp;</span>
            </a>
          </div>
        </div>
        <div className="col-md-5 col-sm-6">
          <p className="ico14 fb">Book Tickets faster. Download our mobile Apps</p>
          <div className="padT10">
            <a
              target="_blank"
              className="fthm-mobApp fthm-goog fl marginR5"
              href="http://app.appsflyer.com/com.goibibo?pid=mobile_site&amp;c=m_header"
              rel="noopener"
            ></a>
            <a
              target="_blank"
              className="fthm-mobApp fthm-app fl marginR5"
              href="https://itunes.apple.com/in/app/goibibo-flight-bus-hotel-booking/id631927169?mt=8"
              rel="noopener"
            ></a>
            <a
              target="_blank"
              className="fthm-mobApp fthm-windows fl"
              href="http://www.windowsphone.com/en-in/store/app/goibibo/6f16a6ec-3b7e-4782-9f74-57f75a4cc1a3"
              rel="noopener"
            ></a>
          </div>
        </div>
        <div className="col-md-5 col-sm-3 marginT5 pad0">
          <span className="commonSprite fl verifySign marginR10">&nbsp;</span>
          <span className="commonSprite fl americanExp marginT5 marginR10 ipaddn">&nbsp;</span>
          <span className="commonSprite fl masterCard marginT5 marginR10 ipaddn">&nbsp;</span>
          <span className="commonSprite fl visaCard marginT5 marginR10 ipaddn">&nbsp;</span>
          <span className="commonSprite payu marginT5 marginR10">&nbsp;</span>
          <span className="commonSprite rupay marginT2 marginR10 ipaddn">&nbsp;</span>
          <span className="commonSprite iata marginR10">&nbsp;</span>
        </div>
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12 footerCopyrights">
        <div className="col-md-8">
          {/* <a className="commonSprite ibGrp" target="_blank" href="http://www.ibibo.com/" rel="noopener"></a> */}
          {/* <span className="commonSprite backslash" href="#"></span> */}
          <a className="commonSprite goib" target="_blank" href="http://www.goibibo.com/" rel="noopener"></a>
          <a
            rel="noopener"
            className="commonSprite redBus"
            target="_blank"
            href="http://www.redbus.in/bus-tickets/"
          ></a>
          {/* <a rel="nofollow" className="commonSprite ads" target="_blank" href="http://www.ibiboads.com/"></a>
              <a rel="nofollow" className="commonSprite ryde" target="_blank" href="http://www.ibiboryde.com/"></a> */}
        </div>
        {/* <div className="fr padT10">
          &copy;
          {' ' + new Date().getFullYear() + ' ibibogroup All rights reserved'}
        </div> */}
      </div>
    </div>
  </div>

  </div>
);
};

export default Footer;
